import { ChangeDetectionStrategy, Component, inject, model, output } from '@angular/core';

import { CommunicationField } from '../../../customer/model/communication-field.model';
import { IdentityField } from '../../../customer/model/identity-field.model';
import { FeatureVisibilityService } from '../../../customer/services/feature-visibility.service';
import { InputFieldComponent } from '../../../form/components/input-field/input-field.component';
import { useI18n } from '../../../i18n/services/i18n.service';
import { PhoneSearchComponent } from '../phone-search/phone-search.component';

@Component({
  selector: 'cdf-form-search-for-customer',
  imports: [InputFieldComponent, PhoneSearchComponent],
  host: {
    class: 'd-flex flex-column gap-2x',
  },
  template: `
    <h3>{{ i18n('headings.searchForCustomer') }}</h3>

    <cdf-input-field
      id="email"
      [placeholder]="i18n('placeholder.email')"
      [(model)]="bmwMiniId"
      [hidden]="featureVisibilityService.isHidden(CommunicationField.EMAIL)"
    />
    <div class="d-flex gap-2x">
      <cdf-input-field
        id="first-name"
        [placeholder]="i18n('placeholder.firstName')"
        [(model)]="firstName"
        [hidden]="featureVisibilityService.isHidden(IdentityField.FIRST_NAME)"
      />
      <cdf-input-field
        id="last-name"
        [placeholder]="i18n('placeholder.lastName')"
        [(model)]="lastName"
        [hidden]="featureVisibilityService.isHidden(IdentityField.LAST_NAME)"
      />
      <cdf-input-field
        id="suffix"
        [placeholder]="i18n('placeholder.suffix')"
        [(model)]="suffix"
        [hidden]="featureVisibilityService.isHidden(IdentityField.SUFFIX)"
      />
    </div>

    <cdf-phone-search [(mobilePhone)]="mobilePhone" [(phone)]="phone" />

    <div class="d-flex gap-2x">
      <cdf-input-field
        id="tax-number"
        [placeholder]="i18n('personalIdentificationNumbers.taxNumber')"
        [(model)]="taxNumber"
        [hidden]="featureVisibilityService.isHidden(IdentityField.TAX_NUMBER)"
      />
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormSearchForCustomerComponent {
  protected readonly i18n = useI18n();
  readonly featureVisibilityService = inject(FeatureVisibilityService);

  readonly firstName = model.required<string | undefined>();
  readonly lastName = model.required<string | undefined>();
  readonly suffix = model.required<string | undefined>();
  readonly bmwMiniId = model.required<string | undefined>();
  readonly mobilePhone = model.required<string | undefined>();
  readonly phone = model.required<string | undefined>();
  readonly taxNumber = model.required<string | undefined>();

  readonly searchCustomer = output();

  protected readonly IdentityField = IdentityField;
  protected readonly CommunicationField = CommunicationField;
}
